import React, { useState, useEffect, useMemo } from "react";
import { Card, Tabs } from "antd";
import {
  ShoppingOutlined,
  TagsOutlined,
  UserOutlined,
  BankOutlined,
  ApiOutlined,
} from "@ant-design/icons";
import ProductTab from "./ProductTab";
import CategoryTab from "./CategoryTab";
import VendorTab from "./PartnerTab";
import BanksTab from "./BanksTab";
import IntegrationsTab from "./IntegrationsTab";
import { useLocation } from "react-router-dom";
import useGlobalFilters from "../../../../hooks/useGlobalFilters";

const Settings = ({ selectedBrand: selectedBrandProp = null }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("1");
  const { selectedBrands } = useGlobalFilters();

  // Use prop if provided, otherwise use first brand from global filters
  const selectedBrand = useMemo(() => {
    if (selectedBrandProp) {
      return selectedBrandProp;
    }
    if (selectedBrands && selectedBrands.length > 0) {
      return selectedBrands[0];
    }
    return null;
  }, [selectedBrandProp, selectedBrands]);

  useEffect(() => {
    // Check if there's a tab specified in the location state (from navigate)
    if (location.state && location.state.activeTab) {
      setActiveTab(location.state.activeTab);
    }
    // Check if there's a tab specified in localStorage (from table column buttons)
    else if (localStorage.getItem("accounting_settings_active_tab")) {
      setActiveTab(localStorage.getItem("accounting_settings_active_tab"));
      // Clear the localStorage item after using it
      localStorage.removeItem("accounting_settings_active_tab");
    }
  }, [location]);

  const tabItems = [
    {
      key: "1",
      label: (
        <span>
          <ShoppingOutlined className="me-2" />
          Products
        </span>
      ),
      children: <ProductTab selectedBrand={selectedBrand} />,
    },
    {
      key: "2",
      label: (
        <span>
          <TagsOutlined className="me-2" />
          Categories
        </span>
      ),
      children: <CategoryTab selectedBrand={selectedBrand} />,
    },
    {
      key: "3",
      label: (
        <span>
          <UserOutlined className="me-2" />
          Partners
        </span>
      ),
      children: <VendorTab selectedBrand={selectedBrand} />,
    },
    {
      key: "5",
      label: (
        <span>
          <BankOutlined className="me-2" />
          Banks
        </span>
      ),
      children: <BanksTab selectedBrand={selectedBrand} />,
    },
    {
      key: "6",
      label: (
        <span>
          <ApiOutlined className="me-2" />
          Integrations
        </span>
      ),
      children: <IntegrationsTab selectedBrand={selectedBrand} />,
    },
  ];

  return (
    <Card title="Accounting Settings" variant="outlined">
      <Tabs activeKey={activeTab} onChange={setActiveTab} items={tabItems} />
    </Card>
  );
};

export default Settings;
